import React from 'react';
import { Container, Paper, Toolbar, Tabs, Tab, Box } from '@mui/material';
import { useLocation, Link, Navigate, Routes, Route, Outlet, useParams } from 'react-router-dom';
import i18next from 'i18next';

import ContactSubjectsTab from './ContactSubjectsTab';
import TaxTypesTab from './TaxTypesTab';
import TaxTypeTab from './TaxTypeTab';
import { TaxTypeCreate } from './TaxTypeTab';
import SystemTab from './SystemTab';
import { userSelector } from 'helper/security';

export default function AdministrationIndex() {
  const location = useLocation();
  const user = userSelector();

  return (
    <>
      <Toolbar />
      <Container maxWidth="xl">
        <Paper>
          <Tabs value={location.pathname === '/administration' ? '/administration/subjects' : location.pathname.split('/').slice(0, 3).join('/')}>
            {user?.isRoot && (
              <Tab
                value="/administration/subjects"
                label={String(i18next.t('contact-subjects-title'))}
                component={Link}
                to="/administration/subjects"
              />
            )}
            {user?.isRoot && (
              <Tab
                value="/administration/taxtypes"
                label={i18next.t('pricelists-tabs-header-taxtypes')}
                component={Link}
                to="/administration/taxtypes"
              />
            )}
            <Tab value="/administration/system" label={String(i18next.t('system'))} component={Link} to="/administration/system" />
          </Tabs>

          <Box p={2}>
            <Routes>
              <Route index element={user?.isRoot ? <ContactSubjectsTab /> : <Navigate to="system" replace />} />
              <Route path="subjects" element={<ContactSubjectsTab />} />
              <Route path="taxtypes/_create" Component={() => <TaxTypeCreate />} />
              <Route path="taxtypes/:id" Component={() => <TaxTypeTab id={parseInt(useParams().id!)} />} />
              <Route path="taxtypes" element={<TaxTypesTab />} />
              <Route path="system" element={<SystemTab />} />
            </Routes>

            <Outlet />
          </Box>
        </Paper>
      </Container>
    </>
  );
}
